import { useSelector } from 'react-redux';
import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import ListViewGraph from './listView-graph';
import { useNavigate } from 'react-router-dom';
import ComptrollerPageHeader from 'components/header/ComptrollerPageHeader';
import { useGetAllGraphDefinationMutation } from 'store/features/comptroller/comptrollerApi';

const GraphAPI = () => {
	const navigate = useNavigate();

	const [GetAllGraphDefination, { data: allGraphDefination, isLoading }] = useGetAllGraphDefinationMutation();
	const { profileData } = useSelector((state) => state?.profile);

	const [activeCreateButton, setActiveCreateButton] = useState(true);
	const [reloadTable, setReloadTable] = useState(false);

	useEffect(() => {
		setActiveCreateButton(isLoading);
	}, [isLoading]);

	//api call for condition master list && employee list
	useEffect(() => {
		if (profileData) {
			GetAllGraphDefination({ companyCode: profileData?.creatorOrganizationId });
		}
		//eslint-disable-next-line
	}, [profileData, reloadTable]);

	//updating state variable with api response for employee list
	useEffect(() => {
		if (allGraphDefination) {
			// if (allGraphDefination?.code === "200") {
			// }
		}
	}, [allGraphDefination]);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<Grid item>
					{/* <Box
            sx={{
              // bgcolor: "#214689",
              borderRadius: 1,
              // pl: "10px",
              // pr: "8px",
              // py: "8px",
              // color: "common.white",
              // mb: "25px",
              width: "100%",
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                bgcolor: "#214689",
                px: "15px",
                py: "12px",
                color: "common.white",
              }}
              style={{ borderRadius: "6px 6px 0 0" }}
            >
              <Stack direction="row" alignItems="center" sx={{ gap: "10px" }}>
                <img alt="comptroller" src={comptroller} width="20px" height="18px" />
                <Typography variant="h4">Graph Defination</Typography>
              </Stack>

              <Button
                type="primary"
                disabled={activeCreateButton}
                onClick={() => navigate("/comptroller/graph-defination/create")}
                sx={{
                  color: "white",
                  display: "flex",
                  fontWeight: 450,
                  boxShadow: "none",
                  padding: "3px 15px",
                  alignItems: "center",
                  transition: "all 0.3s",
                  backgroundColor: activeCreateButton ? "gray" : theme.palette.lynTheme.success,
                  border: `1px solid ${activeCreateButton ? "gray" : theme.palette.lynTheme.success}`,
                  borderColor: "#ffff",

                  "&:hover": {
                    backgroundColor: activeCreateButton ? "gray" : "#207f3b",

                    transform: "scale(0.9)",
                  },
                }}
              >
                <img src={plusIcon} alt="add" width="12" height="12" style={{ marginRight: "8px" }} />
                Create
              </Button>
            </Stack>
          </Box> */}

					<ComptrollerPageHeader
						title="Graph Defination"
						// tabsItem={tabsItem}
						// selectedTab={selectedTab}
						activeCreateButton={activeCreateButton}
						// selectTabHandler={selectTabHandler}
						navigate={() => {
							navigate('/comptroller/graph-defination/create');
						}}
					/>

					<Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
						<Box sx={{ background: '#fff', padding: '20px', borderRadius: '4px' }}>
							<ListViewGraph
								navigate={navigate}
								setReloadTable={setReloadTable}
								graphTable={allGraphDefination?.result}
								isLoading={isLoading}
							/>
						</Box>
					</Box>
					{/* <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
            {tabsItem?.map((item, index) => (
              <TabPanel key={index} value={selectedTab} index={index} sx={{ height: "calc(100% - 38px)" }}>
                <Box sx={{ mt: 2 }}>
                  <ListViewGraph navigate={navigate} setReloadTable={setReloadTable} graphTable={allGraphDefination} isLoading={isLoading} />
                </Box>
              </TabPanel>
            ))}
          </Box> */}
				</Grid>
			</Grid>
		</Grid>
	);
};
export default GraphAPI;
